import React, { useState } from 'react';

import {
  Button, Collapse, UncontrolledTooltip
} from 'reactstrap';


import './styles.css';


const TreeViewNode = (props) => {
  const { item, root } = props;
  const [isOpen, setIsOpen] = useState(root);

  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    !isOpen && props.setIsOpen && props.setIsOpen(true);
    setIsOpen(!isOpen);
  };

  const setActiveItem = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.setActiveItem && props.setActiveItem(item);
    props.setIsOpen && props.setIsOpen(true);
  };

  const Add = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.add && props.add(item);
    setIsOpen(true);
  }

  const Del = (e, fullDel) => {
    e.preventDefault();
    e.stopPropagation();
    props.del && props.del(item, fullDel)
    setIsOpen(false);
  };

  const classNames = item.id == props.active_id ? "linkSelected row" : "row";
  const Buttons = () => (
    <div className="col p-0 text-right">
      {
        item.id == props.active_id &&
        <React.Fragment>
          <Button id="add" color="info" onClick={Add} className="btn-little rounded-circle"><i className="fa fa-plus" aria-hidden="true"></i></Button>
          <UncontrolledTooltip placement="bottom" target="add">
            Crear Link y Asignar como Hijo
          </UncontrolledTooltip>
          <Button id="del1" color="warning" onClick={(e) => Del(e, false)} className="btn-little rounded-circle"><i className="fa fa-times" aria-hidden="true"></i></Button>
          <UncontrolledTooltip placement="bottom" target="del1">
            Borrar Link y Asignar Hijos a Padre
          </UncontrolledTooltip>
          <Button id="del2" color="danger" onClick={(e) => Del(e, true)} className="btn-little rounded-circle"><i className="fa fa-trash" aria-hidden="true"></i></Button>
          <UncontrolledTooltip placement="bottom" target="del2">
            Borrar Link y Hijos
          </UncontrolledTooltip>
        </React.Fragment>
      }
    </div>
  );

  return (
    <li onClick={toggle} draggable="true">
      <div className={classNames}>
        <div className="col p-0">
          {
            item.submenues && item.submenues.length == 0
              ? <p className="m-0 p-0" onClick={(evt) => setActiveItem(evt)}>{item.Nombre}</p>
              : <p>
                <i className={isOpen ? "fa fa-chevron-up" : "fa fa-chevron-down"} aria-hidden="true"></i>
                <span onClick={(evt) => setActiveItem(evt)}>{item.Nombre}</span>
              </p>
          }
        </div>
        <Buttons />
      </div>
      {
        item.submenues && item.submenues.length > 0 &&
        <Collapse isOpen={isOpen}>
          <ul>
            {
              item.submenues.map((subitem) => (
                <TreeViewNode
                  active_id={props.active_id}
                  setActiveItem={props.setActiveItem}
                  key={`link-${subitem.id}`}
                  item={subitem}
                  setIsOpen={(val) => setIsOpen(val)}
                  root={false}
                  del={props.del}
                  add={props.add}
                />
              ))
            }
          </ul>
        </Collapse>
      }
    </li>
  );
}

export default TreeViewNode;



// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Links/TreeViewNode.js